import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationNozzlesPerSide
} from 'services/equipmentSets/types';
import { makeSelectCalibrationNozzlesPerSide } from 'services/equipmentSets/selectors';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    nozzlesPerSide: CalibrationNozzlesPerSide;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsNozzlesPerSideListItem extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { nozzlesPerSide } = this.props;

        return <ListItem description="Nozzles/Side" value={nozzlesPerSide} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    nozzlesPerSide: makeSelectCalibrationNozzlesPerSide()
});

export default connect(mapStateToProps)(
    SummaryCalibrationsNozzlesPerSideListItem
);
